import { Components, Theme } from '@mui/material/styles';

export const MuiSkeleton: Components<Theme>['MuiSkeleton'] = {
  defaultProps: {
    animation: 'wave',
    variant: 'rounded',
  },

  styleOverrides: {
    root: {
      variants: [
        {
          props: { variant: 'pilled' },
          style: {
            borderRadius: '9999px',
          },
        },
      ],
    },
  },
};
